
import { shapeFaireDistanceUnitForApp, shapeFaireMassUnitForApp, shapeKeyDate } from '../../product/shapeAttributes';
import { replaceOperation } from '../../product/operations';
import { editInventory } from '../inventory';
import { toString } from '../../number';
import { getSize } from '../../iterable/getSize';

import { AMOUNT, OPERATIONS, PRICE_API_KEY_TO_ATTRIBUTE_CURRENCY_MAP, VALUE } from '../../../constants/product';
import { EBAY, ETSY, FAIRE, SHOPIFY } from '../../../constants/channels';
import { ATTRIBUTE } from '../../../constants/attributes';
import { EMPTY } from '../../../constants';
import { FORM } from '../../../constants/forms';

export function inventory({ operation, product, shopData, ...rest }) {
  const channel = product.get('channel');
  const operationType = operation.get('type');

  switch (channel) {
    case EBAY: {
      switch (operationType) {
        case OPERATIONS[EBAY].PRICE: {
          const value = operation.getIn(['value', 'value']);
          const updates = editInventory({ product, [ATTRIBUTE.PRICE]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].QUANTITY: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.QUANTITY]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[EBAY].SKU: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.SKU]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    case ETSY: {
      switch (operationType) {
        case OPERATIONS[ETSY].PRICE: {
          const value = operation.getIn(['value', 0, 'value', 'value']);
          const updates = editInventory({ product, shopData, [ATTRIBUTE.PRICE]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[ETSY].QUANTITY: {
          const value = operation.getIn(['value', 0, 'value']);
          const updates = editInventory({ product, shopData, [ATTRIBUTE.QUANTITY]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[ETSY].SKU: {
          const value = operation.getIn(['value', 0, 'value']);
          const updates = editInventory({ product, shopData, [ATTRIBUTE.SKU]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    case FAIRE: {
      switch (operationType) {
        case OPERATIONS[FAIRE].CONTINUE_SELLING: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.CONTINUE_SELLING]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].DEADLINE_DATE: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.PREORDER]: shapeKeyDate(value) });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].DISTANCE_UNIT: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.DISTANCE_UNIT]: shapeFaireDistanceUnitForApp(value) });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].END_DATE: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.PREORDER]: shapeKeyDate(value) });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].GTIN: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.GTIN]: value || '' });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].HEIGHT: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.HEIGHT]: toString(value) });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].KEEP_ACTIVE: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.KEEP_ACTIVE]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].LENGTH: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.LENGTH]: toString(value) });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].MASS_UNIT: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.MASS_UNIT]: shapeFaireMassUnitForApp(value) });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].PREORDER: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.PREORDER]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].QUANTITY: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.QUANTITY]: toString(value) });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].RESTOCK_DATE: {
          const value = operation.get('value') || null;

          if (value !== null && product.getIn([FORM.INVENTORY, ATTRIBUTE.QUANTITY, VALUE]) !== AMOUNT.ZERO) {
            return { ...rest, product };
          }

          const updates = editInventory({ product, [ATTRIBUTE.RESTOCK_DATE]: value && new Date(value) });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].PRICES: {
          const payload = {};

          for (const [key, values] of operation.get('value').entries()) {
            if (!PRICE_API_KEY_TO_ATTRIBUTE_CURRENCY_MAP.hasOwnProperty(key)) continue;

            const { attribute, currency } = PRICE_API_KEY_TO_ATTRIBUTE_CURRENCY_MAP[key];

            if (!payload[attribute]) {
              payload[attribute] = {};
            }

            payload[attribute][currency] = values.get('value') || '';
          }

          if (getSize(payload) === 0) {
            return { product, ...rest };
          }

          const updates = editInventory({ product, ...payload });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].SKU: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.SKU]: value || '' });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].START_DATE: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.PREORDER]: shapeKeyDate(value) });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].TARIFF_CODE: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.TARIFF_CODE]: value || '' });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].WEIGHT: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.WEIGHT]: toString(value) });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[FAIRE].WIDTH: {
          const value = operation.get('value');
          const updates = editInventory({ product, [ATTRIBUTE.WIDTH]: toString(value) });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    case SHOPIFY: {
      switch (operationType) {
        case OPERATIONS[SHOPIFY].BARCODE: {
          const value = operation.getIn(['value', 0, 'value']);
          const updates = editInventory({ product, [ATTRIBUTE.BARCODE]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].CAP: {
          const value = operation.getIn(['value', 0, 'value', 'value']);
          const updates = editInventory({ product, [ATTRIBUTE.CAP]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].CHARGE_TAX: {
          const value = operation.getIn(['value', 0, 'value', 'taxable']);
          const updates = editInventory({ product, [ATTRIBUTE.CHARGE_TAX]: !!value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].CONTINUE_SELLING: {
          const value = operation.getIn(['value', 0, 'value', 'inventoryPolicy']);
          const updates = editInventory({ product, [ATTRIBUTE.CONTINUE_SELLING]: value === 'continue' });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].COUNTRY_CODE: {
          const value = operation.getIn(['value', 0, 'value', 'countryCode']);
          const updates = editInventory({ product, [ATTRIBUTE.COUNTRY_CODE]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].CPI: {
          const value = operation.getIn(['value', 0, 'value', 'value']);
          const updates = editInventory({ product, [ATTRIBUTE.CPI]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].HS_CODE: {
          const value = operation.getIn(['value', 0, 'value', 'hsCode']);
          const updates = editInventory({ product, [ATTRIBUTE.HS_CODE]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].PHYSICAL: {
          const value = operation.getIn(['value', 0, 'value', 'requiresShipping']);
          const updates = editInventory({ product, [ATTRIBUTE.PHYSICAL]: !!value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].PRICE: {
          const value = operation.getIn(['value', 0, 'value', 'value']);
          const updates = editInventory({ product, [ATTRIBUTE.PRICE]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].QUANTITY: {
          const value = operation.getIn(['value', 0, 'value']);
          const updates = editInventory({ product, [ATTRIBUTE.QUANTITY]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].SKU: {
          const value = operation.getIn(['value', 0, 'value']);
          const updates = editInventory({ product, [ATTRIBUTE.SKU]: value });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].TRACK_QUANTITY: {
          const value = operation.getIn(['value', 0, 'value', 'inventoryManagement']);
          const updates = editInventory({ product, [ATTRIBUTE.TRACK_QUANTITY]: value === SHOPIFY });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        case OPERATIONS[SHOPIFY].WEIGHT: {
          const weight = operation.getIn(['value', 0, 'value', 'weight']);
          const unit = operation.getIn(['value', 0, 'value', 'unit']);
          const updates = editInventory({ product, [ATTRIBUTE.WEIGHT]: weight, [ATTRIBUTE.UNIT]: unit });

          return {
            ...rest,
            product: updates.product = updates.product.set('operations',
              updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
            ),
          };
        }

        default: {
          return { product, ...rest };
        }
      }
    }

    default: {
      return { product, ...rest };
    }
  }
}
